// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--yrDzk","content":"b429494557--content--hAZ2r","footer":"b429494557--footer--wy_zf"};